import { useTooltipStyles } from '../ChartTooltipStyles';
import { getStatusColor, getStatusName } from '../../../../utilities/StatusUtilities';

import TimeAndStatus from './TimeAndStatus';

export default function StatusTooltip({ chartDef, timeslice }) {
    const classes = useTooltipStyles();

    const nonZeroItems = timeslice?.items?.filter((item) => item.value);

    if (!nonZeroItems || !nonZeroItems.length) return null;

    const item = nonZeroItems[0];
    const statusValue = item.def.key;
    const statusColor = getStatusColor(statusValue);
    const statusName = getStatusName(statusValue);

    return (
        <div>
            <TimeAndStatus chartDef={chartDef} timeslice={timeslice} />
            <table className={classes.tooltipTable}>
                <tbody>
                    <tr className={classes.tooltipPoint}>
                        <td>
                            <div className={classes.tooltipPointColorBox} style={{ backgroundColor: statusColor }} />
                        </td>
                        <td className={classes.tooltipPointLabel}>Status:</td>
                        <td className={classes.tooltipPointValue}>{statusName}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
